function setBackground() {
    $('[setBackground]').each(function() {
        var background = $(this).attr('setBackground')
        $(this).css({
            "background-image": "url(" + background + ")",
            "background-size": "cover",
            "background-position": "center center"
        })
    })
    $('[setBackgroundRepeat]').each(function() {
        var background = $(this).attr('setBackgroundRepeat')
        $(this).css({
            "background-image": "url(" + background + ")",
            "background-repeat": "repeat"
        })
    })
}

function equalHeight(el) {
    let height = 0;
    let thisHeight = 0;
    $(el).each(function() {
        thisHeight = $(this).height();
        if (thisHeight > height) {
            height = thisHeight;
        }
    });
    $(el).height(height)
}

function scrollToSection() {
    $('.homeslide .button').on('click', function(e) {
        e.preventDefault()
        let i = $('.home-gioithieu').offset().top - $('header').height()
        $('html,body').animate({
            scrollTop: i
        }, 1000)

    })
}
///fixed
function headerfixed() {
    if ($(window).scrollTop() > 0) {
        $('header').addClass('fixed')
    } else {
        $('header').removeClass('fixed')
    }
    $(window).on('scroll', function() {
        if ($(window).scrollTop() > 0) {
            $('header').addClass('fixed')
        } else {
            $('header').removeClass('fixed')
        }
    })

}
//searchbox
function searchbox() {
    $('.iconsearch').on('click', function() {
        $('.searchbox').toggleClass('active')
    });
}
//toggle header
function toggleHeader() {
    $('.toggle-button').on('click', function() {
            $('.sidebar-menu').toggleClass('active')
            $(this).toggleClass('active')
        })
        //   $(window).on('click', function() {
        //     $('.sidebar-menu').removeClass('active')
        //  })
}

function movemenu() {
    var movecall = new MappingListener({
        selector: '.main-menu',
        mobileWrapper: '.sidebar-menu',
        mobileMethod: 'appendTo',
        desktopWrapper: '.minhgiang-logo',
        desktopMethod: 'insertAfter',
        breakpoint: 1200,
    }).watch()
}

function movecall() {
    var movecall = new MappingListener({
        selector: '.call',
        mobileWrapper: '.sidebar-menu',
        mobileMethod: 'appendTo',
        desktopWrapper: '.language',
        desktopMethod: 'insertAfter',
        breakpoint: 1200,
    }).watch()
}

function language() {
    $('.lang-active').on('click', function() {
        $('.lang-list').slideToggle()
    })
}

function hampurger() {
    var $hamburger = $(".hamburger");
    $hamburger.on("click", function(e) {
        $hamburger.toggleClass("is-active");
        // Do something else, like open/close menu
    });
}
// home slider
function homeslide() {
    var swiper = new Swiper('.homeslide .swiper-container', {
        slidesPerView: 1,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.homeslide .swiper-navigation .swiper-btn.swiper-next',
            prevEl: '.homeslide .swiper-navigation .swiper-btn.swiper-prev',
        },
    });
}
//tin tuc 
function TintucSlider() {
    var swiper = new Swiper('.home-tintuc .swiper-container', {
        slidesPerView: 3,
        spaceBetween: 30,
        freeMode: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 1,
                spaceBetween: 10
            },
            1025: {
                slidesPerView: 2,
                spaceBetween: 10
            },
        },
    });
}

function Dealers() {
    $(document).on('change', '.dealer-district', function() {
        $('.dealer-button input').trigger('click')
    })
}

function gotop() {
    $('#gotop').on('click', function() {
        $('html,body').animate({
            scrollTop: 0
        }, 1000)
    })
}

function mainNavigation() {
    $('.mg-navigation .mobile-heading').on('click', function() {
        $(this).siblings().slideToggle()
    })
}

function toggleZoneProductList() {
    $('.san-pham-ds .zone-group .zone-group-heading').on('click', function() {
        $(this).toggleClass('active')
        $(this).siblings().slideToggle()
    })
    $('.san-pham-ds .zone-group .zone-group-list .zone-group-item.active').parents('.zone-group').find('.zone-group-heading').trigger('click')
}

function customSelect() {
    $('[data-select] .select-heading').on('click', function(e) {
        $('[data-select] .select-heading').not(this).siblings('.select-list').removeClass('active')
        $(this).siblings('.select-list').toggleClass('active')
        $('html').one('click', function() {
            $('[data-select] .select-list').removeClass('active')
        });
        e.stopPropagation();
    })

    // $('#menucontainer').click(function(event) {
    //     event.stopPropagation();
    // });
    // $('.san-pham-ds .filter-wrapper .filter-group .filter-select-heading').on('click', function() {
    //     $(this).siblings('.filter-select-list').fadeToggle()
    // })
}

function productDetailSlider() {
    var GalleryThumb = new Swiper('.san-pham-ct .product-thumb-wrapper .swiper-container', {
        spaceBetween: 10,
        slidesPerView: 5,
        direction: 'vertical',
        speed: 1000,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            1025: {
                direction: 'horizontal',

            }
        },
        on: {
            init: function() {
                if ($(window).outerWidth() < 1025) {
                    $('.san-pham-ct .product-thumb-wrapper .swiper-slide').each(function() {
                        setTimeout(() => {

                            $(this).height($(this).width())
                        }, 500);
                    })
                }
            },
        }

    })
    let GalleryTop = new Swiper('.san-pham-ct .product-active-wrapper .swiper-container', {
        effect: 'fade',
        thumbs: {
            swiper: GalleryThumb
        },
        speed: 500,
        autoplay: {
            delay: 3000
        },
        navigation: {
            clickable: true,
            nextEl: '.san-pham-ct .swiper-btn.swiper-next',
            prevEl: '.san-pham-ct .swiper-btn.swiper-prev'
        }

    });

}

function relatedSlider() {
    var swiper = new Swiper('.related-wrapper .swiper-container', {
        slidesPerView: 4,
        spaceBetween: 10,
        autoplay: {
            delay: 4000
        },
        speed: 1000,
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            1025: {
                slidesPerView: 3
            },
            576: {
                slidesPerView: 1
            }
        },
    });
}

function partnerSlider() {
    var swiper = new Swiper('.doi-tac .swiper-container', {
        slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 30,
        autoplay: {
            delay: 4000
        },
        speed: 1000,
        breakpoints: {
            1025: {
                slidesPerView: 2
            },
            576: {
                slidesPerView: 1,
                slidesPerColumn: 1
            }
        },
        navigation: {
            clickable: true,
            nextEl: '.doi-tac .swiper-btn.swiper-next',
            prevEl: '.doi-tac .swiper-btn.swiper-prev'
        }
    });
}

function megaHeader() {
    $('header .has-mega .mega-show').on('click', function() {
        $(this).parents('.has-mega').find('.mega-wrapper').addClass('active')
    })
    $('header .has-mega .mega-back').on('click', function() {
        $(this).parents('.has-mega').find('.mega-wrapper').removeClass('active')
    })
}

function moveOrderSelect() {
    if ($('.san-pham-ds .filter-wrapper .order-select').length) {
        var movecall = new MappingListener({
            selector: '.san-pham-ds .filter-wrapper .order-select',
            mobileWrapper: '.san-pham-ds .product-wrapper .product-heading .product-order span',
            mobileMethod: 'insertAfter',
            desktopWrapper: '.san-pham-ds .product-wrapper .product-heading .product-order span',
            desktopMethod: 'insertAfter',
            breakpoint: 1200,
        }).watch()
    }
}

function productDetailTab() {
    $('.san-pham-ct .detail-wrapper .detail-tab .item').on('click', function() {
        let active = $(this).attr('data-tab')
        $('.san-pham-ct .detail-wrapper .detail-tab .item').removeClass('active')
        $(this).addClass('active')
        $('.san-pham-ct .detail-wrapper .detail-content .item').removeClass('active')
        $('.san-pham-ct .detail-wrapper .detail-content .item[data-content=' + active + ']').addClass('active')
    })
    $('.san-pham-ct .detail-wrapper .detail-tab .item:first-child').trigger('click')
}

function mappingFeedbackWrapper() {
    if ($('.commentpanel').length) {
        $('.commentpanel').appendTo($('.san-pham-ct .detail-wrapper .detail-content .item[data-content="2"]'))
    }
}
$(document).ready(function() {
    headerfixed()
    searchbox()
    setBackground()
    toggleHeader()
    hampurger()
    movecall()
    movemenu()
    megaHeader()
    homeslide()
    language()
    moveOrderSelect()
    TintucSlider()
    gotop()
    Dealers()
    relatedSlider()
    scrollToSection()
    mainNavigation()
    customSelect()
    partnerSlider()
    productDetailTab()
    toggleZoneProductList()
    productDetailSlider()
    mappingFeedbackWrapper()
    setTimeout(() => {
        equalHeight('.home-tintuc .swiper-container .swiper-wrapper .swiper-slide figure .img img')
        equalHeight('.gioi-thieu-4 .item')
        equalHeight('.news-item figure h4')
        equalHeight('.news-item .image')
        equalHeight('.zone-item figcaption')
        equalHeight('.product-item figcaption h4')
        equalHeight('.product-item figcaption ul')
        equalHeight('.product-item figcaption')
        equalHeight('.product-item .image')
        equalHeight('.partner-item .image')
    }, 100);

    $(".news-detail .social-share").jsSocials({
        showLabel: false,
        showCount: false,
        shares: [{
            share: 'twitter',
            logo: 'fab fa-twitter'
        }, {
            share: 'facebook',
            logo: 'fab fa-facebook-f'
        }, {
            share: 'linkedin',
            logo: 'fab fa-linkedin-in'
        }]
    })
});